<template>
  <lf-card class="w-full flex-1 space-y-5 bg-white p-3">
    <div class="flex justify-between">
      <lf-h3 class="capitalize">{{ title }}</lf-h3>
      <div @click="$emit('openEditModal')">
        <icon-base :icon="IconEdit" class="ml-2 cursor-pointer" />
      </div>
    </div>
    <slot></slot>
  </lf-card>
</template>
<script setup lang="ts">
import IconEdit from "@/components/icons/IconEdit.vue";

defineEmits<{
  openEditModal: [void];
}>();

defineProps<{
  title: string;
}>();
</script>
